import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider, useAuth } from './auth/AuthContext';
import './styles.css';
import { makeTrpcClient, trpc } from './trpc/client';

function TrpcBridge({ children }: { children: React.ReactNode }) {
  const { idToken } = useAuth();
  const queryClient = useMemo(() => new QueryClient(), []);
  const trpcClient = useMemo(() => makeTrpcClient(idToken), [idToken]);
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TrpcBridge>
          <App />
        </TrpcBridge>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
